module.exports = __webpack_public_path__ + "img/1875.3826e38f.gif";